import { CSSProperties, useEffect, useState } from 'react';
import Loading from '../../../components/Loading';
import CollapseCard from '../../../components/CollapseCard';
import { ExecutionTypes } from '../../../interfaces/ExecutionTypes';
import { formatTimestampToDate } from '../../../utils/dateUtils';
import { TestCaseTypes } from '../../../interfaces/TestCaseTypes';
import EmptyState from '../../../components/EmptyState';
import DownIcon from '@mui/icons-material/ArrowDropDown';
import UpIcon from '@mui/icons-material/ArrowDropUp';
import LineIcon from '@mui/icons-material/UnfoldMoreOutlined';
import PassedIcon from '@mui/icons-material/Check';
import FailedIcon from '@mui/icons-material/Close';
import { colors } from '../../../assets/colors';
import { ProjectsTypes } from '../../../interfaces/ProjectsTypes';
import { deleteExecution, getExecutions } from '../../../api/projects';
import { useParams } from 'react-router-dom';
import { USER_DATA } from '../../../utils/constants';
import TrashIcon from '@mui/icons-material/Delete';
import { toast } from 'react-toastify';
import Row from '../../../components/layout/Row';
import { Box } from '@mui/material';
import SubTitle from '../../../components/SubTitle';
import DialogViewImage from '../components/DialogViewImage';
import DialogConfirm from '../../../components/DialogConfirm';
import { mountHistory } from '../../../utils/history';
import { createHistory } from '../../../api/history';
import { ActionTypeEnum } from '../../../interfaces/HistoryTypes';

interface Props {
    currentProject: ProjectsTypes;
}

export default function ExecutionsTab({
    currentProject,
}: Props) {

    const { id } = useParams()

    const [loading, setLoading] = useState(true);
    const [executions, setExecutions] = useState([]);

    const [openImage, setOpenImage] = useState(false);
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const [imageToView, setImageToView] = useState<string>('');
    const [executionSelected, setExecutionSelected] = useState({} as ExecutionTypes);

    useEffect(() => {
        fetchExecutions()
    }, [])

    const fetchExecutions = async () => {
        setLoading(true);

        getExecutions(String(id))
            .then((response: any) => {
                setExecutions(response)
                setLoading(false);
            })
    }

    const resultBar = (execution: ExecutionTypes) => {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', border: '1px solid #ccc', borderRadius: 5, width: '100%' }}>
                <div style={{ width: `${String(execution.totalPassed)}%`, height: 10, backgroundColor: colors.status.green }}></div>
                <div style={{ width: `${String(execution.totalFailed)}%`, height: 10, backgroundColor: colors.status.red }}></div>
                <div style={{ width: `${String(execution.totalIgnored)}%`, height: 10, backgroundColor: colors.status.yellow }}></div>
            </div>
        )
    }

    const backgroundColorResult = (result: any) => {
        switch (result) {
            case 'PASSED':
                return '#00800020'
            case 'IGNORED':
                return '#FFA6002F'
            case 'FAILED':
                return '#FF00001C'
            default:
                return '#F6F4F4A5'
        }
    };

    // repetido
    const renderPriority = (priority: string) => {

        switch (priority) {
            case 'LOW':
                return <UpIcon sx={{ color: 'green' }} />
            case 'MEDIUM':
                return <LineIcon sx={{ color: 'orange' }} />
            case 'HIGH':
                return <DownIcon sx={{ color: 'red' }} />;
            default:
                return <LineIcon sx={{ color: 'orange' }} />
        }
    };

    const removeExecution = (responseOk: boolean, id: string) => {
        if (!responseOk) {
            setOpenConfirmDelete(false)
            return;
        }

        deleteExecution(id)
            .then(() => {
                toast.success('Execução removida com sucesso')
                createHistory(mountHistory(currentProject.project_id, ActionTypeEnum.DELETE, "Execução"))
            })
            .catch((e) => {
                toast.error('Ocorreu um problema, tente mais tarde!')
            })
            .finally(() => {
                fetchExecutions()
                setOpenConfirmDelete(false)
            })
    }

    const onViewImage = (img: string) => {
        setImageToView(img)
        setOpenImage(true)
    };

    return (
        <>
            {loading &&
                <div style={style.content}>
                    <Loading />
                </div>
            }

            <div style={style.content}>
                {!loading && executions.map((execution: ExecutionTypes, execindex: number) => {
                    return (
                        <CollapseCard
                            key={execindex + execution.id}
                            title={'Execução ' + ' - ' + formatTimestampToDate(execution.date)}
                            moreInfo={resultBar(execution)}
                            open={false}
                            iconDelete={<TrashIcon sx={style.iconSuite} />}
                            actionDelete={() => {
                                setOpenConfirmDelete(true)
                                setExecutionSelected(execution)
                            }}
                        >

                            {execution.result.map((result, index) =>

                                <Box key={index + result.id} style={style.testCasesContainer} >

                                    <Row style={{ gap: 12 }}>
                                        <span>Total de casos de testes: <strong>{result.test_cases.length}</strong></span>
                                        <span>|</span>
                                        <strong style={{ color: colors.status.green }}>Passou: <strong>{result.test_cases.filter((test_case: TestCaseTypes) => test_case.result === 'PASSED').length}</strong></strong>
                                        <span>|</span>
                                        <strong style={{ color: colors.status.red }}>Falhou: <strong>{result.test_cases.filter((test_case: TestCaseTypes) => test_case.result === 'FAILED').length}</strong></strong>
                                        <span>|</span>
                                        <strong style={{ color: colors.status.yellow }}>Ignorou: <strong>{result.test_cases.filter((test_case: TestCaseTypes) => test_case.result === 'IGNORED' || test_case.result === '' || test_case.result === null).length} </strong></strong>

                                    </Row>

                                    <h1 style={style.suiteTitle}>{result.title}</h1>

                                    {result.test_cases.map((test_case: TestCaseTypes, subindex) =>
                                        <Box key={subindex + test_case.id} style={{ ...style.testCaseContent, backgroundColor: backgroundColorResult(test_case.result) }} >

                                            <Box key={index + subindex + test_case.id} style={style.infoContainer}>

                                                <Box style={style.testCaseTitleContainer}>
                                                    <span key={subindex + test_case.id} style={style.testCaseTitle} >
                                                        {renderPriority(test_case.priority)}
                                                        {test_case.title}
                                                    </span>

                                                    <p key={subindex} style={style.testCaseSteps} >
                                                        <strong>Pré condições: </strong><br />{test_case.pre_conditions}
                                                    </p>

                                                    <p key={subindex} style={style.testCaseSteps} >
                                                        <strong>Passos: </strong><br />{test_case.steps}
                                                    </p>

                                                    <p key={subindex} style={style.testCaseSteps} >
                                                        <strong>Esperado: </strong><br />{test_case.expected_result}
                                                    </p>
                                                </Box>

                                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                                    {test_case.result === 'PASSED' &&
                                                        <div style={{ backgroundColor: test_case.result === 'PASSED' ? 'green' : 'white', border: '1px solid green', ...style.buttonResultContent }}>
                                                            <PassedIcon style={{ color: test_case.result === 'PASSED' ? 'white' : 'green' }} />
                                                        </div>
                                                    }

                                                    {test_case.result === 'FAILED' &&
                                                        <div style={{ backgroundColor: test_case.result === 'FAILED' ? 'red' : 'white', border: '1px solid red', ...style.buttonResultContent }}>
                                                            <FailedIcon style={{ color: test_case.result === 'FAILED' ? 'white' : 'red' }} />
                                                        </div>
                                                    }
                                                </div>
                                            </Box>

                                            {test_case.result === 'FAILED' &&
                                                <div style={style.testCaseReasonContainer}>
                                                    <SubTitle text='Motivo da Falha:' />
                                                    <p style={style.testCaseReason} >
                                                        {test_case.reason}
                                                    </p>
                                                    <SubTitle text='Evidência: ' style={{ marginTop: 4, marginBottom: 0 }} />
                                                    <img onClick={() => onViewImage(test_case.image_failure!)}
                                                        src={test_case.image_failure} style={style.testCaseReasonImage}
                                                    />

                                                </div>
                                            }
                                        </Box>
                                    )}
                                </Box>
                            )}
                        </CollapseCard>
                    )
                })}
            </div>

            {currentProject && executions.length === 0 && !loading &&
                <EmptyState text="Nenhuma execução encontrada." />
            }

            {openImage &&
                <DialogViewImage
                    imageToView={imageToView}
                    open={openImage}
                    close={() => setOpenImage(false)}
                />
            }

            {openConfirmDelete && (
                <DialogConfirm
                    onResponse={(responseOk) => removeExecution(responseOk, String(executionSelected.id))}
                    entity="essa execução"
                />
            )}

        </>
    );
};

const style: { [key: string]: CSSProperties } = {
    content: {
        backgroundColor: colors.white,
        marginTop: 50,
        marginLeft: 12,
        marginRight: 12
    },

    iconSuite: {
        color: colors.gray,
        width: 16,
        height: 16
    },

    suiteTitle: {
        fontSize: 18,
        fontWeight: "600",
        marginTop: 24,
    },

    testCasesContainer: {
        width: '100%',
        marginTop: 10,
        padding: 24
    },

    testCaseContent: {
        padding: 8,
        marginTop: 8,
        borderRadius: 6,
    },

    infoContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: 8,
        paddingRight: 8,
    },

    testCaseTitleContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: 12,
        marginRight: 24
    },

    testCaseTitle: {
        margin: 16,
        justifyContent: 'start',
        alignItems: 'center',
        display: 'flex',
        marginLeft: -10,
        fontWeight: 500,
        color: colors.black,
        width: '100%',
    },

    testCaseSteps: {
        fontSize: 12,
        color: colors.gray,
        whiteSpace: 'pre-wrap',
        minHeight: 100,
        width: '100%',
    },

    buttonResultContent: {
        width: 28,
        height: 28,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 100,
        cursor: 'pointer',
        marginRight: 8,
        marginLeft: 8
    },

    testCaseReasonContainer: {
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: 16,
        padding: 16,
        margin: 8,
        borderRadius: 8,
        backgroundColor: '#FEDDDDFF',
    },

    testCaseReason: {
        fontSize: 12,
        width: '100%',
        whiteSpace: 'pre-wrap',
    },

    testCaseReasonImage: {
        marginTop: 12,
        width: '10%',
        cursor: 'pointer',
    }
}
